import { cn } from '@/helpers/shadCnUtils';

export const TableWrapper = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <div className={cn('h-full flex-grow overflow-hidden py-2', className)}>{children}</div>;
};
